<button
  [type]="btnType"
  [ngClass]="btnClass"
  class="text-center py-1 px-4 text-base"
  [disabled]="disabled">
  <ng-content></ng-content>
</button>
